import * as yup from 'yup'

export const authSchema = yup.object().shape({
  email: yup
    .string()
    .required('Email is required')
    .email('Please enter a valid email address'),

  phoneNumber: yup
    .string()
    .test('Phone number length check', (value, context) => {
      if (!value.length) {
        return true
      }

      const regex = new RegExp('^[0-9]+$')
      if (!regex.test(value)) {
        return context.createError({
          message: 'Phone number should be numbers only',
        })
      }

      if (value && value.length !== 10) {
        return context.createError({
          message: 'Phone number should be 10 characters',
        })
      }

      return true
    })
    .required('Phone number is required'),
  acceptTerms: yup
    .boolean()
    .test('should accept terms', 'Please accept terms', (value) => value),
})

export const authSchemaWithoutTerms = yup.object().shape({
  email: yup
    .string()
    .required('Email is required')
    .email('Please enter a valid email address'),

  phoneNumber: yup
    .string()
    .test('Phone number length check', (value, context) => {
      if (!value.length) {
        return true
      }

      const regex = new RegExp('^[0-9]+$')
      if (!regex.test(value)) {
        return context.createError({
          message: 'Phone number should be numbers only',
        })
      }

      if (value && value.length !== 10) {
        return context.createError({
          message: 'Phone number should be 10 characters',
        })
      }

      return true
    })
    .required('Phone number is required'),
})

export const verificationCodeSchema = yup.object().shape({
  verificationCode: yup
    .string()
    .test('Verification code check', (value, context) => {
      if (!value) {
        return context.createError({
          message: 'Verification code is required',
        })
      }

      return true
    })
    .required(),
})
